// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__DJfqB","image":"Header_image__2QaW3","name":"Header_name__1oHDr","info":"Header_info__JBXkz","infoRow":"Header_infoRow__2LRDb"};